import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../../Apis/request";
import { BaseURL, uniqueToken } from "../../../api/DataApis";
import axios from "axios";

function Add(props) {
  const { pid } = useParams();
  document.title = "Filter Category List | Add";
  let navigate = useNavigate();
  let location = useLocation();
  let FilterCategoryViewData = location?.state?.FilterCategoryViewData;
  const sluggg = FilterCategoryViewData?.slug;
  console.log("sluggggg", sluggg);

  const [TitleName, setTitleName] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [FilterCategoryData, setFilterCategoryData] = useState([]);
  const [connectorocppData, setconnectorocppData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAdditionalInputs, setShowAdditionalInputs] = useState(false);
  const [ChargerData, setChargerData] = useState([]);
  const [selectedOcppConnector, setSelectedOcppConnector] = useState("0");
  const [selectedPower, setSelectedPower] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const [PowerListing, setPowerListing] = useState([]);
  const [Vehiclesnames, setVehiclesnames] = useState([]);

  useEffect(() => {
    // Fetch countries on component mount
    const fetchPowerListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/master/power-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setPowerListing(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchPowerListing();
  }, []);

  useEffect(() => {
    // Fetch countries on component mount
    const fetchVehicleNamesListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/master/vehicles-name-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setVehiclesnames(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchVehicleNamesListing();
  }, []);

  // New state for the additional input field
  const [additionalInput, setAdditionalInput] = useState("");

  // Show input if sluggg is 'dc-0' or 'ac-0'
  useEffect(() => {
    if (sluggg === "dc-0" || sluggg === "ac-0") {
      setShowAdditionalInputs(true);
    } else {
      setShowAdditionalInputs(false);
    }
  }, [sluggg]);

  const handleTitleName = (e) => {
    setTitleName(e.target.value);
  };

  const handlePowerInput=(e)=> {
setSelectedPower([e.target.value]);
};

const handleVehicleInput=(e)=> {
  setSelectedVehicle(e.target.value);
  };

  const handleStatusType = (e) => {
    setSelectedStatusType(e.target.value);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  // Handle additional input value
  const handleAdditionalInput = (e) => {
    setSelectedOcppConnector(e.target.value.replace(/\D/, "")); // Ensure only integers are entered
  };

  const AddFilterCategory = async () => {
    let formData = new FormData();
    formData.append("title", TitleName);
    // formData.append("status", selectedStatusType);
    if (pid) {
      formData.append("parent_id", pid);
    }
    if( selectedFile ) {
      formData.append("master_image", selectedFile);
    }
     // Add selected OCPP connector to formData

    // Add additional input to formData if applicable
    if (showAdditionalInputs) {
    formData.append("connectorId", selectedOcppConnector);
    }
    if (selectedPower) {
      formData.append("master_select_power_id", selectedPower);
      }
      if (selectedVehicle) {
        formData.append("master_select_vehicle_type_id", [selectedVehicle]);
        }

    setLoading(true);
    Swal.fire({
      title: 'Adding Category...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      let response = await request({
        url: `${BaseURL}/master/`,
        method: "POST",
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });

      if (response.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Filter Category Added Successfully...",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/masters/filtercategorylist`);
      } else {
        const errorMessage = response.data.message || "Failed to add Filter Category";
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });
      }
    } catch (error) {
      console.error("Error in AddFilterCategory:", error);
      const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
      });
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      {FilterCategoryViewData?.title ? (
                        <>Filter Category Add - ({FilterCategoryViewData.title})</>
                      ) : (
                        <>Filter Category Add</>
                      )}
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr style={{ marginTop: "-5px" }} />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Title
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleTitleName}
                                className="form-control"
                                id="name_id"
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="file"
                              className="col-sm-2 control-label"
                            >
                              Image
                            </label>
                            <div className="col-sm-6">
                              <input
                                type="file"
                                onChange={handleFileChange}
                                className="form-control"
                                id="file"
                                name="file"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        {/* <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="statusType"
                              className="col-sm-2 control-label"
                            >
                              Status
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleStatusType}
                                className="form-control"
                                id="statusType"
                                name="statusType"
                              >
                                <option value="0">Select Status</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div> */}
                        
                        {/* Additional input field for sluggg 'dc-0' or 'ac-0' */}
                        {showAdditionalInputs && (
                          <>
                          <div className="form-group">
                            <div className="row">
                              <label
                                htmlFor="additional_input"
                                className="col-sm-2 control-label"
                              >
                                Connector ID
                              </label>
                              <div className="col-sm-6">
                                <input
                                  type="number"
                            
                                  onChange={handleAdditionalInput}
                                  className="form-control"
                                  id="additional_input"
                                  placeholder="Enter an integer"
                                />
                              </div>
                              <span className="col-sm-4 control-label"></span>
                            </div>
                          </div>

<div className="form-group">
<div className="row">
  <label
    htmlFor="additional_input"
    className="col-sm-2 control-label"
  >
    Power
  </label>
  <div className="col-sm-6">
    <select
    

      onChange={handlePowerInput}
      className="form-control"
      id="additional_input"
      placeholder="Enter an integer"
    >
      <option value="">Select Power</option>
      {PowerListing?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
      </select>
  </div>
  <span className="col-sm-4 control-label"></span>
</div>
</div>
<div className="form-group">
<div className="row">
  <label
    htmlFor="additional_input"
    className="col-sm-2 control-label"
  >
    Vehicle
  </label>
  <div className="col-sm-6">
    <select
      

      onChange={handleVehicleInput}
      className="form-control"
      id="additional_input"
      placeholder="Enter an integer"
    >
      <option value="">Select Vehicle</option>
      {Vehiclesnames?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
      </select>
  </div>
  <span className="col-sm-4 control-label"></span>
</div>
</div>
</>
                          
                        )}

                        <div className="form-group">
                          <div className="row">
                            <div className="col-sm-6">
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={AddFilterCategory}
                              >
                                Add Filter Category
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
